import React from 'react'
import { BackToMainMenuLink } from './Main'

export default ({ view }) => (
  <div className='layout-width-constraint pt9'>
    <div className='flex'>
      <BackToMainMenuLink view={view} />
    </div>
  </div>
)
